import React from 'react';
import { Navigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ThemeOption } from '@/components/OtherMenu/ThemeOption';
import { ArrowLeft } from '@/components/Icons/ArrowLeft';
import { useIsMobile } from '@/hooks/useIsMobile';
import { useTheme } from '@/hooks/useTheme';
import { Layout } from '@/layouts/Layout';
import { ROUTE_HOME } from '@/router/routes';
import { THEMES } from '@/types/theme';
import { goToPreviousPage } from '@/utils/global';

export const OtherTheme: React.FC = () => {
  const { t } = useTranslation();
  const { theme, setTheme } = useTheme();
  const isMobile = useIsMobile();

  if (!isMobile) {
    return <Navigate to={ROUTE_HOME} replace />;
  }

  const mobileHeader = (
    <div className="flex w-full items-center md:hidden">
      <button
        type="button"
        onClick={goToPreviousPage}
        aria-label={t('global.back')}
        className="flex size-6 shrink-0 cursor-pointer items-center justify-center text-foreground"
      >
        <ArrowLeft />
      </button>
    </div>
  );

  return (
    <Layout hideMobileNavbar mobileHeader={mobileHeader}>
      <div className="flex flex-1 flex-col gap-6 px-4 pb-8 md:px-6 md:pt-6">
        <h1 className="text-[24px]/[30px] font-semibold text-foreground md:text-title-24">
          {t('sidebar.tabs.themeSwitcher')}
        </h1>
        <div role="radiogroup" className="flex flex-col gap-2">
          {THEMES.map((value) => (
            <ThemeOption
              key={value}
              theme={value}
              isSelected={value === theme}
              onSelect={setTheme}
            />
          ))}
        </div>
      </div>
    </Layout>
  );
};
